module.exports = __webpack_public_path__ + "img/2-m.ee777faa.jpg";